import Cancel from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { Divider, Grid, Typography } from '@mui/material';
import { ValidationErrors } from 'fluentvalidation-ts';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  createNewAppServicePlan,
  RemoveDuplicateAppserviceplans,
} from '../../../Common/CommonMethods';
import CustomButton from '../../../Common/Components/Controls/InputControls';
import { Loader } from '../../../Common/Components/Loader';
import {
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../Common/CommonComponents';
import { customerService } from '../Customer/CustomerService';
import { farmService } from '../ManageFarms/FarmService';
import { SqlServer } from '../SqlServer/Model/SqlServerModel';
import { sqlServerService } from '../SqlServer/SqlServerService';
import { StorageAccount } from '../StorageAccount/Model/StorageAccountModel';
import { storageAccountService } from '../StorageAccount/StorageAccountService';
import { AzureSearchService } from '../SearchService/Model/AzureSearchServiceModel';
import { azureSearchServiceService } from '../SearchService/AzureSearchServiceService';
import TenantRegistrationForm from './Components/TenantRegistrationForm';
import { RegisterTenant, TenantForm } from './Model/TenantModels';
import { showToast } from '../../../lib/toast';

interface Param {
  customerId: string;
}

export default function TenantRegistration() {
  const params = useParams<Param>();
  const history = useHistory();
  const [registerTenant, setRegisterTenant] = useState<RegisterTenant>();
  const [FarmId, setFarmId] = useState<string>();
  const [loading, setLoading] = useState(true);
  const [storageAccounts, setStorageAccounts] = useState<StorageAccount[]>([]);
  const [azureSearchServices, setAzureSearchServices] = useState<
    AzureSearchService[]
  >([]);
  const [sqlServers, setSqlServers] = useState<SqlServer[]>([]);
  const [replicaServers, setReplicaServers] = useState<SqlServer[]>([]);
  const [sqlServer, setSqlserver] = useState('');
  const [openAppserviceDialogue, setOpenAppserviceDialogue] = useState(false);
  const [azureSearchService, setAzureSearchService] = useState('');
  const [storageAccount, setStorageAccount] = useState('');
  const [appserviceplans, setAppserviceplans] = useState<string[]>([]);
  const [replicas, setreplicas] = useState<string[]>([]);
  const [appserviceplan, setAppserviceplan] = useState('');
  const [selectedValue, setSelectedValue] = useState('Not Selected');
  const [tenantErrors, setTenantErrors] = useState<
    ValidationErrors<TenantForm>
  >({});

  const addItemToState = (item: string[]) => {
    const newItem = createNewAppServicePlan(
      appserviceplans,
      item,
      Number(FarmId),
    );
    const newItemString = Array.isArray(newItem) ? newItem[0] : newItem;

    const updatedAppServicePlans = RemoveDuplicateAppserviceplans([
      ...appserviceplans,
      newItemString,
    ]);

    setAppserviceplans(updatedAppServicePlans);
    setAppserviceplan(newItemString);
  };

  const handleCloseAppservicePlan = (value: string) => {
    setOpenAppserviceDialogue(false);
    if (value !== 'Not Selected') {
      setSelectedValue(value);
      addItemToState([value]);
    }
  };

  const loadStorageAccounts = async () => {
    try {
      await storageAccountService
        .getstorageAccounts()
        .then((storageAccounts) => {
          setStorageAccounts(
            storageAccounts.Items.filter(
              (sa) => sa.Purpose.toLowerCase() === 'archive',
            ),
          );
        });
    } catch (error) {
      console.log(error);
    }
  };
  const loadAzureSearchServices = async () => {
    try {
      await azureSearchServiceService
        .getAzureSearchServices()
        .then((azureSearchServices) => {
          setAzureSearchServices(azureSearchServices.Items);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const loadSqlServers = async () => {
    try {
      await sqlServerService.getSqlServers().then((sqlservers) => {
        setSqlServers(sqlservers.Items);
        setReplicaServers(sqlservers.Items);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handlRegister = async () => {
    if (
      FarmId !== undefined &&
      storageAccount !== '' &&
      azureSearchService !== '' &&
      appserviceplan !== ''
    ) {
      setLoading(true);
      const baseTenant: TenantForm = {
        AppservicePlan: appserviceplan,
        CustomerId: params.customerId,
        FarmId: FarmId,
        Replicas: replicas,
        SqlServer: sqlServer,
        StorageAccount: storageAccount,
        AzureSearchService: azureSearchService,
      };
      await customerService.RegisterTenant(baseTenant).then(() => {
        showToast({
          type: 'success',
          title: 'Tenant Registered Successfully!',
        });
        setLoading(false);
      });
      history.push('/customer');
    } else {
      showToast({
        type: 'error',
        title: 'All fields are required',
      });
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setFarmId(value);
    const farmId = Number(value);
    loadAppserviceplans(farmId);
    setStorageAccounts(
      storageAccounts.filter(
        (sa) =>
          sa.AzureRegion ===
          registerTenant?.Farms.find((farm) => farm.Id === farmId)?.FarmRegion,
      ),
    );
    setAzureSearchService('');
    setSqlServers(
      sqlServers.filter(
        (server) =>
          server.Region ===
          registerTenant?.Farms.find((farm) => farm.Id === farmId)?.FarmRegion,
      ),
    );
    setSqlserver('');
  };
  const handleClose = () => {
    history.push('/customer');
  };

  const handleReplicaChange = (values: string[]) => {
    let duplicatesRemoved: string[] = [];

    values.forEach((item) => {
      if (duplicatesRemoved.findIndex((o) => o === item) >= 0) {
        duplicatesRemoved = duplicatesRemoved.filter((x) => x === item);
      } else {
        duplicatesRemoved.push(item);
      }
    });

    if (!(duplicatesRemoved.length > 3)) {
      setreplicas(duplicatesRemoved);
    } else {
      showToast({
        type: 'error',
        title:
          'More than 3 replicas are not allowed. please unselect any other',
      });
    }
  };

  const loadAppserviceplans = (farmId: number) => {
    farmService.getAppservicePlans(farmId).then((appserviceplans) => {
      setAppserviceplans(appserviceplans);
    });
  };

  const handleClickOpen = () => {
    setOpenAppserviceDialogue(true);
  };

  useEffect(() => {
    const loadRegisterTenant = async () => {
      await customerService
        .getRegisterTenant(params.customerId)
        .then((data) => {
          setRegisterTenant(data);
          setLoading(false);
        });
    };
    loadRegisterTenant().catch((err) => console.log(err));
    loadStorageAccounts().catch((err) => console.log(err));
    loadAzureSearchServices().catch((err) => console.log(err));
    loadSqlServers();
  }, [params.customerId]);
  return (
    <>
      <div>
        <PaperWrapper>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Register Tenant
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Loader loading={loading} />
          <TenantRegistrationForm
            FarmId={FarmId ?? ''}
            appserviceplan={appserviceplan}
            setAppserviceplan={setAppserviceplan}
            appserviceplans={appserviceplans}
            customerId={params.customerId}
            storageAccount={storageAccount}
            setStorageAccount={setStorageAccount}
            storageAccounts={storageAccounts}
            azureSearchService={azureSearchService}
            setAzureSearchService={setAzureSearchService}
            azureSearchServices={azureSearchServices}
            sqlServers={sqlServers}
            sqlServer={sqlServer}
            replicaServers={replicaServers}
            setSqlServer={setSqlserver}
            handleChange={handleChange}
            handleClickOpen={handleClickOpen}
            registerTenant={registerTenant}
            handleCloseAppservicePlan={handleCloseAppservicePlan}
            openAppserviceDialogue={openAppserviceDialogue}
            selectedValue={selectedValue}
            setOpenAppserviceDialogue={setOpenAppserviceDialogue}
            handleReplicaSelection={handleReplicaChange}
            replicas={replicas}
            errors={tenantErrors}
            setErrors={setTenantErrors}
          />
          <FooterWrapper>
            <FooterContainer>
              <Grid item xs={12} sm="auto">
                <CustomButton
                  variant="contained"
                  onClick={handlRegister}
                  startIcon={<SaveIcon />}
                  label="Register"
                />
              </Grid>
              <Grid item xs={12} sm="auto">
                <CustomButton
                  variant="contained"
                  onClick={handleClose}
                  startIcon={<Cancel />}
                  label="Cancel"
                />
              </Grid>
            </FooterContainer>
          </FooterWrapper>
        </PaperWrapper>
      </div>
    </>
  );
}
